module.exports = __webpack_public_path__ + "img/Icon feather-heart.be7b7397.svg";